import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ILang } from '../../../model/lang.interface';

@Component({
    selector: 'alert-notification-popup',
    templateUrl: 'alert.notification.popup.component.html',
    styleUrls: ["./alert.notification.popup.component.scss"],
})
export class AlertNotificationPopupComponent {
    @Input() active: boolean;
    @Input() currentLang: ILang;
    @Input() leadId: number = 0;
    @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private navCtrl: NavController
    ) {
    }

    public goToLeadClient() {

        var elem = document.getElementsByClassName('lead-client-routing')[0];
        if (elem) {
            elem.classList.remove('lead-client-hidden');
            elem.classList.add('lead-client-visible');
        }

        this.navCtrl.navigateForward(`/leadClients/${this.leadId}`);
    }

    public close(): void {
        this.active = false;
        this.activeChange.emit(false);
    }
}